// Module
var code = "<a href=\"[[ url ]]\" target=\"[[target]]\" class=\"cursor-pointer\" on-click=\"[[goTo(event)]]\"> <div view=\"Content\"></div> </a> ";
// Exports
export default code;